const experinceData = [
	{
		courseTitle: 'B.Sc. in Computer Science and Engineering',
		orgName: 'K.M. Humaiyun Kabir Engineering College',
		time: 'Studying',
		category: 'accademyc',
	},
	{
		courseTitle: 'Higher School Certificate',
		orgName: 'Mymensingh Govt. College',
		time: '2021',
		category: 'accademyc',
	},
	{
		courseTitle: 'Secondary School Certificate',
		orgName: 'Mukul Niketon High School',
		time: '2019',
		category: 'accademyc',
	},
	{
		courseTitle: `Flutter App Development`,
		orgName: 'WS Cube Tech',
		time: '2024',
		category: 'course',
	},
	{
		courseTitle: 'Flutter Mobile App Development: Free Course',
		orgName: 'Ostad',
		time: '2024',
		category: 'course',
	},
	{
		courseTitle: `React Tutorial`,
		orgName: 'Anisul Islam',
		time: '2023',
		category: 'course',
	},
	{
		courseTitle: `Javascript: All You Need To Know`,
		orgName: 'Stack Learner',
		time: '2023',
		category: 'course',
	},
	{
		courseTitle: 'PSD TO HTML',
		orgName: 'Youtube',
		time: '2021',
		category: 'course',
	},
];

export default experinceData;
